// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'  // 安装axios后引入
import smart from 'address-smart-parse'


Vue.prototype.$axios = axios  // 将axios挂载到原型上方便使用

//https://blog.csdn.net/Mrbignose/article/details/107042903
//import VDistpicker from 'v-distpicker'
//Vue.component('v-distpicker', VDistpicker)

// vue中导出excel表格模板
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

Vue.prototype.$FileSaver = FileSaver; //设置全局
Vue.prototype.$XLSX = XLSX; //设置全局

//https://gitee.com/streamchen/ex-table-column
/*
import ExTableColumn from 'ex-table-column';
Vue.component(ExTableColumn.name, ExTableColumn);
*/



//import {Base64} from 'js-base64'

//Vue.use(Base64);
Vue.use(elementUI);
Vue.use(VueWechatTitle);

Vue.config.productionTip = false

Vue.use(VueClipboard);
//VueClipboard.config.autoSetContainer = true

/*const originalPush = router.prototype.push;
router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};*/




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js